// 暫時這樣寫 之後會串接後端 API
import logo from 'img/logo/logo.webp';
import './index.css';

const Logo = () => {
  return(
       <img src={logo} className="logo" alt="logo" />
  )
}

export default Logo
